export default {
  lastVersionSeen() {
    return localStorage.getItem('lastVersionSeen');
  },
};
